import { Entity, Field } from "typegraph";

import Entry from "./Entry";

@Entity({one: "assignment", many: "assignmentsUser"})
export default class Assignment {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public description: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field({entity: Entry})
	public entry: Entry;

}



// WEBPACK FOOTER //
// ./src/panels/assignments/entities/Assignment.ts